import { createErrorDataSelector } from 'selectors/selectorUtils';
import { createSelector } from 'reselect';

const getDeleteAssetError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.deleteAsset?.loadingStatus,
        error: powertrainTools?.deleteAsset?.error,
        errorCode: powertrainTools?.deleteAsset?.error?.statusCode
    };
};

const getDleteAsset = ({ powertrainTools }) => {
    return powertrainTools?.deleteAsset;
};

// Memoized selector for default delete asset error data
const getDeleteAssetErrorData = createErrorDataSelector(getDeleteAssetError);

export const getModel = createSelector(
    [
        getDeleteAssetErrorData,
        getDleteAsset
    ],
    (
        deleteAssetErrorData,
        deleteAsset
    ) => {
        return {
            deleteAssetErrorData,
            deleteAsset
        };
    }
);
